import { useSelector } from 'react-redux';
import { isMobileLayout } from 'components/Shared/responsive';
import styles from './imageWithCaption.scss';
import { Reducer, useEffect, useReducer } from 'react';
import { getGetImageUrl } from 'services/ApiKnowledgebaseService';

interface ImageWithCaptionProps {
  text: string;
  image: string;
  imagewidth: string;
  align: string;
}

interface ImageState {
  image: string;
}

const initialImageState: ImageState = {
  image: ''
};

type ImageAction = { type: 'image'; value: string };

const imageReducer: Reducer<ImageState, ImageAction> = (state, action) => {
  switch (action.type) {
    case 'image': {
      return { ...state, image: action.value };
    }
    default:
      return state;
  }
};

export const ImagewithCaption = ({ text, image, imagewidth, align }: ImageWithCaptionProps) => {
  const [state, dispatch] = useReducer(imageReducer, initialImageState);
  const mobile = useSelector(isMobileLayout);

  useEffect(() => {
    void getGetImageUrl(image).then(response => {
      dispatch({ type: 'image', value: response.url });
    });
  }, [image]);

  const baseStyle = { textAlign: align === '1' ? ('right' as const) : ('left' as const) };
  const imageStyle = { width: mobile ? '100%' : `${imagewidth}px` };

  return (
    <div className={styles.base} style={baseStyle}>
      <img src={state.image} title={text} style={imageStyle} />
      <span>{text}</span>
    </div>
  );
};
